export const BORDER = "1px solid #E3E4E7";


// const MOCK_CONVERSATIONS = [
//   {
//     firstName: "Jarmo",
//     lastName: "Berglund",
//     customerOrgName: "Jankon Betoni",
//     timestamp: 1744795467354,
//     latestMessage:
//       "Tämä on viimeisin erittäin pitkä, mielenkiintoinen ja tärkeä viesti, joka on lähetetty tähän keskusteluun jonkun toimesta.",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
//   {
//     firstName: "Anna",
//     lastName: "Korhonen",
//     customerOrgName: "Korhonen Consulting",
//     timestamp: 1744795467355,
//     latestMessage: "Hei, voisitko tarkistaa viimeisimmän tarjouksen?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 0,
//   },
//   {
//     firstName: "Mikko",
//     lastName: "Virtanen",
//     customerOrgName: null,
//     timestamp: 1744795467356,
//     latestMessage: "Kiitos nopeasta vastauksesta!",
//     latestMessageUserFirstName: "Simo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Laura",
//     lastName: "Lehtinen",
//     customerOrgName: "Lehtinen Logistics",
//     timestamp: 1744795467357,
//     latestMessage: "Voimmeko siirtää palaveria ensi viikkoon?",
//     latestMessageUserFirstName: "Pekka",
//     unreadMessages: 3,
//   },
//   {
//     firstName: "Pekka",
//     lastName: "Mäkelä",
//     customerOrgName: "Mäkelä Rakennus",
//     timestamp: 1744795467358,
//     latestMessage: "Tilaus on nyt valmis toimitettavaksi.",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 0,
//   },
//   {
//     firstName: "Sari",
//     lastName: "Hämäläinen",
//     customerOrgName: "Hämäläinen Solutions",
//     timestamp: 1744795467359,
//     latestMessage: "Voitko lähettää lisätietoja projektista?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 4,
//   },
//   {
//     firstName: "Antti",
//     lastName: "Nieminen",
//     customerOrgName: "Nieminen Partners",
//     timestamp: 1744795467360,
//     latestMessage: "Tämä on muistutus tulevasta määräajasta.",
//     latestMessageUserFirstName: "Seppo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Kaisa",
//     lastName: "Salminen",
//     customerOrgName: "Salminen Tech",
//     timestamp: 1744795467361,
//     latestMessage: "Onko sinulla hetki aikaa keskustella?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
//   // copied from above
//   {
//     firstName: "Mikko",
//     lastName: "Virtanen",
//     customerOrgName: null,
//     timestamp: 1744795467356,
//     latestMessage: "Kiitos nopeasta vastauksesta!",
//     latestMessageUserFirstName: "Simo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Laura",
//     lastName: "Lehtinen",
//     customerOrgName: "Lehtinen Logistics",
//     timestamp: 1744795467357,
//     latestMessage: "Voimmeko siirtää palaveria ensi viikkoon?",
//     latestMessageUserFirstName: "Pekka",
//     unreadMessages: 3,
//   },
//   {
//     firstName: "Pekka",
//     lastName: "Mäkelä",
//     customerOrgName: "Mäkelä Rakennus",
//     timestamp: 1744795467358,
//     latestMessage: "Tilaus on nyt valmis toimitettavaksi.",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 0,
//   },
//   {
//     firstName: "Sari",
//     lastName: "Hämäläinen",
//     customerOrgName: "Hämäläinen Solutions",
//     timestamp: 1744795467359,
//     latestMessage: "Voitko lähettää lisätietoja projektista?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 4,
//   },
//   {
//     firstName: "Antti",
//     lastName: "Nieminen",
//     customerOrgName: "Nieminen Partners",
//     timestamp: 1744795467360,
//     latestMessage: "Tämä on muistutus tulevasta määräajasta.",
//     latestMessageUserFirstName: "Seppo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Kaisa",
//     lastName: "Salminen",
//     customerOrgName: "Salminen Tech",
//     timestamp: 1744795467361,
//     latestMessage: "Onko sinulla hetki aikaa keskustella?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
//   {
//     firstName: "Mikko",
//     lastName: "Virtanen",
//     customerOrgName: null,
//     timestamp: 1744795467356,
//     latestMessage: "Kiitos nopeasta vastauksesta!",
//     latestMessageUserFirstName: "Simo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Laura",
//     lastName: "Lehtinen",
//     customerOrgName: "Lehtinen Logistics",
//     timestamp: 1744795467357,
//     latestMessage: "Voimmeko siirtää palaveria ensi viikkoon?",
//     latestMessageUserFirstName: "Pekka",
//     unreadMessages: 3,
//   },
//   {
//     firstName: "Pekka",
//     lastName: "Mäkelä",
//     customerOrgName: "Mäkelä Rakennus",
//     timestamp: 1744795467358,
//     latestMessage: "Tilaus on nyt valmis toimitettavaksi.",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 0,
//   },
//   {
//     firstName: "Sari",
//     lastName: "Hämäläinen",
//     customerOrgName: "Hämäläinen Solutions",
//     timestamp: 1744795467359,
//     latestMessage: "Voitko lähettää lisätietoja projektista?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 4,
//   },
//   {
//     firstName: "Antti",
//     lastName: "Nieminen",
//     customerOrgName: "Nieminen Partners",
//     timestamp: 1744795467360,
//     latestMessage: "Tämä on muistutus tulevasta määräajasta.",
//     latestMessageUserFirstName: "Seppo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Kaisa",
//     lastName: "Salminen",
//     customerOrgName: "Salminen Tech",
//     timestamp: 1744795467361,
//     latestMessage: "Onko sinulla hetki aikaa keskustella?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
//   {
//     firstName: "Mikko",
//     lastName: "Virtanen",
//     customerOrgName: null,
//     timestamp: 1744795467356,
//     latestMessage: "Kiitos nopeasta vastauksesta!",
//     latestMessageUserFirstName: "Simo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Laura",
//     lastName: "Lehtinen",
//     customerOrgName: "Lehtinen Logistics",
//     timestamp: 1744795467357,
//     latestMessage: "Voimmeko siirtää palaveria ensi viikkoon?",
//     latestMessageUserFirstName: "Pekka",
//     unreadMessages: 3,
//   },
//   {
//     firstName: "Pekka",
//     lastName: "Mäkelä",
//     customerOrgName: "Mäkelä Rakennus",
//     timestamp: 1744795467358,
//     latestMessage: "Tilaus on nyt valmis toimitettavaksi.",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 0,
//   },
//   {
//     firstName: "Sari",
//     lastName: "Hämäläinen",
//     customerOrgName: "Hämäläinen Solutions",
//     timestamp: 1744795467359,
//     latestMessage: "Voitko lähettää lisätietoja projektista?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 4,
//   },
//   {
//     firstName: "Antti",
//     lastName: "Nieminen",
//     customerOrgName: "Nieminen Partners",
//     timestamp: 1744795467360,
//     latestMessage: "Tämä on muistutus tulevasta määräajasta.",
//     latestMessageUserFirstName: "Seppo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Kaisa",
//     lastName: "Salminen",
//     customerOrgName: "Salminen Tech",
//     timestamp: 1744795467361,
//     latestMessage: "Onko sinulla hetki aikaa keskustella?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
//   {
//     firstName: "Sari",
//     lastName: "Hämäläinen",
//     customerOrgName: "Hämäläinen Solutions",
//     timestamp: 1744795467359,
//     latestMessage: "Voitko lähettää lisätietoja projektista?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 4,
//   },
//   {
//     firstName: "Antti",
//     lastName: "Nieminen",
//     customerOrgName: "Nieminen Partners",
//     timestamp: 1744795467360,
//     latestMessage: "Tämä on muistutus tulevasta määräajasta.",
//     latestMessageUserFirstName: "Seppo",
//     unreadMessages: 1,
//   },
//   {
//     firstName: "Kaisa",
//     lastName: "Salminen",
//     customerOrgName: "Salminen Tech",
//     timestamp: 1744795467361,
//     latestMessage: "Onko sinulla hetki aikaa keskustella?",
//     latestMessageUserFirstName: "user",
//     unreadMessages: 2,
//   },
// ];